import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';

import { 
    pushHistoryWithErrorNotFound,
    pushHistoryWithLanding 
} from '../../utils/routing';
import {  
    downloadMulti
} from '../../utils/functions';

import Main from '../Main/Main';
import Timer from './Timer';

import { 
    AUTODOWNLOAD_CLICK,  
    DOWNLOAD_DIR,  
    DOWNLOAD_INFO_FILES,
    DOWNLOAD_INFO_GREAT,
    DOWNLOAD_INFO_GREAT_AND_LOAD,
    DOWNLOAD_INFO_HALF_TIME_100s,
    DOWNLOAD_INFO_HALF_TIME_10s,
    DOWNLOAD_INFO_HALF_TIME_20s,
    DOWNLOAD_INFO_HALF_TIME_30s,
    DOWNLOAD_INFO_HALF_TIME_40s,
    DOWNLOAD_INFO_HALF_TIME_50s,
    DOWNLOAD_INFO_HALF_TIME_60s,
    DOWNLOAD_INFO_HALF_TIME_70s,
    DOWNLOAD_INFO_HALF_TIME_80s,
    DOWNLOAD_INFO_HALF_TIME_90s,
    DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE,
    DOWNLOAD_INFO_LOAD,
    DOWNLOAD_INFO_ZIP,
    //DOWNLOAD_START_MAIN, 
    DOWNLOAD_START_TIMER,  
    HERE_CLICK 
} from './translations';

import styles from './DownloadPage.module.css';


export default class DownloadPage extends Component {
    static propTypes = {
        lastGameVersionId: PropTypes.number,

        zipOriginalName: PropTypes.string,
        zipSize: PropTypes.number,

        isZipReady: PropTypes.bool,
        isFetching: PropTypes.bool,
    };

    constructor(props) {
        super(props)

        this.state = {
            countMods: 0,
            seconds: 0,
            isActiveTimer: true,
        }
    }

    componentDidMount() { 
        if (this.props.location.state === null) { // this.props.location.state.downloadUrls.length !== 0
            pushHistoryWithErrorNotFound(this.props.history)
        } else {
            if (this.props.location.state.downloadUrls.basket_items.length > 1) {
                this.setState({countMods: this.props.location.state.downloadUrls.basket_items.length})
                this.props.archivator(this.props.location.state.downloadUrls)
            } else {
                this.setState({countMods: 1})
                //this.handleClickDownloadHere()
            }
            
            this.loadingInfo()
        }
    }

    handleClickDownloadHere = () => {
        const infoElement = document.getElementById('download_info')
        infoElement.textContent = DOWNLOAD_INFO_GREAT_AND_LOAD

        if (this.state.countMods === 1) {
            downloadMulti(DOWNLOAD_DIR(this.props.location.state.downloadUrls.basket_items[0].originalFileName), '')
        } else {
            downloadMulti(DOWNLOAD_DIR(this.props.zipOriginalName), '')
        }

        window.setTimeout(()=> pushHistoryWithLanding(this.props.history), 1000)
    }

    loadingInfo() {
        if (this.props.location.state.downloadUrls.basket_items.length > 0) {
            const interval = setInterval(() => {
                const infoElement = document.getElementById('download_info')
                const supportElement = document.getElementById('download_support')
                // set interval seconds
                if (this.state.isActiveTimer) {
                    this.setState({seconds: this.state.seconds + 1})
                    // set interval info
                    if (this.state.seconds >= 5 && this.state.seconds <= 8) {
                        infoElement.textContent = DOWNLOAD_INFO_ZIP
                    } else if (this.state.seconds >= 9 && this.state.seconds <= 13) {
                        infoElement.textContent = DOWNLOAD_INFO_LOAD
                    } else if (this.state.seconds >= 14 && this.state.seconds <= 19) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_10s
                    } else if (this.state.seconds >= 20 && this.state.seconds <= 29) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_20s
                    } else if (this.state.seconds >= 30 && this.state.seconds <= 39) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_30s
                    } else if (this.state.seconds >= 40 && this.state.seconds <= 49) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_40s
                    } else if (this.state.seconds >= 50 && this.state.seconds <= 59) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_50s
                    } else if (this.state.seconds >= 60 && this.state.seconds <= 69) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_60s
                    } else if (this.state.seconds >= 70 && this.state.seconds <= 79) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_70s
                    } else if (this.state.seconds >= 80 && this.state.seconds <= 89) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_80s
                    } else if (this.state.seconds >= 90 && this.state.seconds <= 99) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_90s
                    } else if (this.state.seconds >= 100 && this.state.seconds <= 109) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_TANK_ADVICE+DOWNLOAD_INFO_HALF_TIME_100s
                    } else if (this.state.seconds >= 110) {
                        infoElement.textContent = DOWNLOAD_INFO_HALF_TIME_30s
                    }
                } // end of IF this.state.isActiveTimer

                if (this.state.countMods === 1) {
                    if (this.state.seconds >= 2) {
                        infoElement.textContent = DOWNLOAD_INFO_GREAT
                        // stop interval
                        this.setState({isActiveTimer: false})

                        supportElement.classList.remove(styles.hide)
                        // start downloading file
                        this.handleClickDownloadHere()
                    }
                } else {
                    // check for ready file
                    if (this.props.zipOriginalName !== null) {
                        // check fileSize in props and on server
                        if (this.state.seconds % 10 === 0) {
                            this.props.checkFileSize({'zipOriginalName': this.props.zipOriginalName, 'zipSize': this.props.zipSize})
                        }

                        if (this.props.isZipReady) {
                            infoElement.textContent = DOWNLOAD_INFO_GREAT
                            // stop interval
                            this.setState({isActiveTimer: false})

                            supportElement.classList.remove(styles.hide)
                            // start downloading file
                            this.handleClickDownloadHere()
                        }
                    }
                } // end of IF this.state.countMods
            }, 1000); // end of const interval

            return () => clearInterval(interval)
        } else {
            pushHistoryWithErrorNotFound(this.props.history)
        }
    }

    render() {
        return (
            <Main>
                <div className={styles.body}>
                    <div className={styles.block}>
                        <div className={styles.title}>
                            <span id="download_info">{DOWNLOAD_INFO_FILES}&nbsp;</span>
                            {/* <span>Скачивание начнется через&nbsp;</span><mark id="download_timer"></mark><span>&nbsp;секунд</span> */}
                        </div>
                        <div className={styles.content}>
                            <span>{DOWNLOAD_START_TIMER(<Timer isActive={this.state.isActiveTimer} />)}</span>&nbsp;
                        </div>
                        <div className={classNames(styles.content, styles.hide)} id="download_support">
                            <span>{AUTODOWNLOAD_CLICK}&nbsp;
                            <span style={{color: 'var(--main-blue-color)',cursor: 'pointer',textDecoration: 'underline'}} onClick={() => this.handleClickDownloadHere()}>{HERE_CLICK}</span></span>
                        </div>
                    </div>
                </div>
            </Main>
        )
    }
}
